module.exports = __webpack_public_path__ + "static/loop_title-98c61f6dc4fc8d03412ffa88767a9457.mp4";